<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />

    <b-card>
      <data-table
        :fields="reqsFields"
        ep="v2/ministry/requests"
        id="ngos-requests"
      />
    </b-card>
  </div>
</template>
<script>
import DataTable from "@/components/data-table/index.vue";
import { BCard } from "bootstrap-vue";
export default {
  components: {
    DataTable,
    BCard,
  },
  data() {
    return {
      mainTitle: "الأسئلة الأكثر شيوعاً",

      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "الأسئلة و الأجوبة",
          active: true,
        },
      ],
      reqsFields: [
        {
          key: "name",
          label: "الاسم",
        },
      ],
    };
  },
};
</script>
